import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manager-card',
  templateUrl: './manager-card.component.html',
  styleUrls: ['./manager-card.component.scss']
})
export class ManagerCardComponent {

  @Input() title: string
  @Input() data: number
  @Input() route: string

  constructor(
    private router: Router,
  ) { }

  public goToLink(): void {
    this.router.navigate([this.route]);
  }
}
